import { Flex, MDIIcon } from '@solinkcorp/solink-components';
import FaceblurIcon from '@solinkcorp/solink-components/svg/faceblur.svg?react';
import classNames from 'classnames';
import styles from './FaceblurOverlay.module.sass';
interface FaceblurOverlayProps {
  hidden: boolean;
}
export default function FaceblurOverlay(props: FaceblurOverlayProps) {
  return (
    <Flex
      className={classNames(styles.faceBlurOverlay, { [styles.hidden]: props.hidden })}
      height="100%"
      width="100%"
      justifyContent="center"
      alignItems="center"
      zIndex={4}
    >
      <MDIIcon size={54} fill="white" icon={FaceblurIcon} />
    </Flex>
  );
}
